import { c as _c } from "react/compiler-runtime";
import { useContext } from 'react';
import { AccordionContext } from '../helpers/AccordionContext';
import { AccordionItemID } from '../state/accordionStore.types';
export const useAccordionItemOpened = id => {
  const $ = _c(5);
  const context = useContext(AccordionContext);
  if (context == null) {
    throw new Error("useAccordionItemOpened must be used within a AccordionProvider");
  }
  const {
    accordionState,
    defaultOpened
  } = context;
  let t0;
  if ($[0] !== accordionState.defaultItemOpenedState || $[1] !== accordionState.items || $[2] !== defaultOpened || $[3] !== id) {
    t0 = accordionState.items.get(id) ?? accordionState.defaultItemOpenedState ?? defaultOpened?.has(id) ?? false;
    $[0] = accordionState.defaultItemOpenedState;
    $[1] = accordionState.items;
    $[2] = defaultOpened;
    $[3] = id;
    $[4] = t0;
  } else {
    t0 = $[4];
  }
  return t0;
};
export const useAreAllItemsOpened = itemsCount => {
  const context = useContext(AccordionContext);
  if (context == null) {
    throw new Error("useAccordionOpenedItemsCount must be used within a AccordionProvider");
  }
  const {
    items,
    defaultItemOpenedState
  } = context.accordionState;
  const areAllKnownItemsOpened = [...items.values()].every(Boolean);
  if (defaultItemOpenedState === true) {
    return areAllKnownItemsOpened;
  }
  return items.size === itemsCount && areAllKnownItemsOpened;
};
export const useAreAllItemsClosed = itemsCount => {
  const context = useContext(AccordionContext);
  if (context == null) {
    throw new Error("useAccordionOpenedItemsCount must be used within a AccordionProvider");
  }
  const {
    items,
    defaultItemOpenedState
  } = context.accordionState;
  const areAllKnownItemsClosed = [...items.values()].every(_temp);
  if (defaultItemOpenedState === false || defaultItemOpenedState === null) {
    return areAllKnownItemsClosed;
  }
  return items.size === itemsCount && areAllKnownItemsClosed;
};
export const useDispatchAccordion = () => {
  const context = useContext(AccordionContext);
  if (context == null) {
    throw new Error("useDispatchAccordion must be used within a AccordionProvider");
  }
  return context.dispatchOpenedItems;
};
function _temp(item) {
  return item === false;
}